import { Pipe, PipeTransform, Inject } from '@angular/core';
import { BringozVolumePipe } from './bringoz-volume.pipe';

@Pipe({
  standalone: false,
  name: 'packageVolume'
})
export class PackageVolumePipe implements PipeTransform {

  constructor(
    @Inject('splitService') private splitService,
    @Inject(BringozVolumePipe) private bringozVolumePipe: BringozVolumePipe
  ) {}

  transform(packageList: any[], enableUnitDisplay: boolean): string {
    let totalVolume = 0;
    let hasAnyVolume = false;

    if (Array.isArray(packageList) && packageList.length) {
      packageList.forEach(pkg => {
        if (pkg?.items?.length) {
          pkg.items.forEach(item => {
            const volume = item.dimensions?.cube;
            if (volume !== undefined) {
              hasAnyVolume = true;
            }
            totalVolume += volume || 0;
          });
        }
      });
    }

    return hasAnyVolume
      ? this.bringozVolumePipe.transform(totalVolume, enableUnitDisplay)
      : '---';
  }
}



// import { Pipe, PipeTransform, Inject } from '@angular/core';
// import { BringozVolumePipe } from './bringoz-volume.pipe';
//
// @Pipe({
//     name: 'packageVolume'
// })
// export class PackageVolumePipe implements PipeTransform {
//
//     constructor(
//         @Inject('splitService') private splitService,
//         @Inject(BringozVolumePipe) private bringozVolumePipe: BringozVolumePipe
//     ) {}
//
//     transform(packageRef: any, enableUnitDisplay: boolean): string {
//         let itemsVolumeSum = 0;
//         let hasAnyVolume = false;
//
//         if (packageRef && packageRef.items?.length) {
//             itemsVolumeSum = packageRef.items.reduce((sum, item) => {
//                 const volume = item.dimensions?.cube;
//                 if (volume !== undefined) {
//                     hasAnyVolume = true;
//                 }
//                 return sum + (volume || 0);
//             }, 0);
//         }
//
//         return hasAnyVolume
//             ? this.bringozVolumePipe.transform(itemsVolumeSum, enableUnitDisplay)
//             : '---';
//     }
// }
